import { initializeApp } from 'firebase/app';
import {
  getToken,
  Messaging,
  onMessage,
  isSupported,
  getMessaging,
} from 'firebase/messaging';

const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
  appId: import.meta.env.VITE_FIREBASE_APP_ID,
};

const app = initializeApp(firebaseConfig);

let messaging: Messaging | null = null;

const getMessagingInstance = async (): Promise<Messaging | null> => {
  if (messaging) return messaging;

  try {
    const supported = await isSupported();
    if (supported) {
      messaging = getMessaging(app);
    } else {
      console.warn('Firebase messaging is not supported in this browser');
    }
  } catch (error) {
    console.error('Failed to initialize Firebase messaging:', error);
  }

  return messaging;
};

export { getToken, onMessage, getMessagingInstance };
